import {
  LuChartLine,
  LuCalendarDays,
  LuClipboardList,
  LuUsers,
  LuMessageCircle,
  LuUserCheck,
  LuBuilding2,
  LuCircleUser,
  LuSettings,
  LuShieldCheck,
} from 'react-icons/lu';
import AppIcon from '../components/icons/app-icon';

const navIcon = (icon: Parameters<typeof AppIcon>[0]['icon']) => (
  <AppIcon icon={icon} size={21} />
);

const sidebarNav = [
  {
    link: '/report',
    section: 'report',
    icon: navIcon(LuChartLine),
    text: 'Report',
  },
  {
    link: '/events',
    section: 'events',
    icon: navIcon(LuCalendarDays),
    text: 'Events',
  },
  {
    link: '/forms',
    section: 'forms',
    icon: navIcon(LuClipboardList),
    text: 'Forms',
  },
  {
    link: '/users',
    section: 'users',
    icon: navIcon(LuUsers),
    text: 'Users',
  },
  {
    link: '/whatsapp',
    section: 'whatsapp',
    icon: navIcon(LuMessageCircle),
    text: 'WhatsApp',
  },
  {
    link: '/guests',
    section: 'guests',
    icon: navIcon(LuUserCheck),
    text: 'Guests',
  },
  {
    link: '/organizations',
    section: 'organizations',
    icon: navIcon(LuBuilding2),
    text: 'Organizations',
  },
  {
    link: '/super-admin',
    section: 'super-admin',
    icon: navIcon(LuShieldCheck),
    text: 'Platform',
    superAdminOnly: true,
  },
  {
    link: '/profile',
    section: 'profile',
    icon: navIcon(LuCircleUser),
    text: 'Profile',
  },
  {
    link: '/settings',
    section: 'settings',
    icon: navIcon(LuSettings),
    text: 'Settings',
  },
];

export default sidebarNav;
